import React from "react";
import { Row, Col, Input } from "reactstrap";
import PropTypes from "prop-types";

const ImportReportSelectBox = ({
    loading,
    setImportProsprEmployeeReportModal,
    setImportLaborSpreadsheetReportModal,
    setImportSpotHeroReportModal,
    setImportSureParkReportModal,
    setImportAmanoReportModal,
}) => {
    const handleImportSelect = (e) => {
        const value = e.target.value;

        switch (value) {
            case "prospr":
                setImportProsprEmployeeReportModal(true);
                break;
            case "labor":
                setImportLaborSpreadsheetReportModal(true);
                break;
            case "spothero":
                setImportSpotHeroReportModal(true);
                break;
            case "surepark":
                setImportSureParkReportModal(true);
                break;
            case "amano":
                setImportAmanoReportModal(true);
                break;
            default:
                break;
        }

        // Reset back to placeholder after selection
        e.target.value = "";
    };

    return (
        <Row className="mt-3 w-100">
            <Col xs={12} md={12} lg={12} className="mb-2">
                <Input
                    type="select"
                    className="form-select form-select-lg accordion-gradient-border text-center"
                    style={{ minWidth: "220px" }}
                    defaultValue=""
                    disabled={loading}
                    onChange={handleImportSelect}
                >
                    <option value="" disabled>
                        {loading ? "Loading..." : "Import A Report"}
                    </option>
                    <option value="prospr">Import Prospr Report</option>
                    {/* <option value="labor">Import Labor Spreadsheet Report</option> */}
                    <option value="spothero">Import SpotHero Report</option>
                    <option value="surepark">Import SurePark Report</option>
                    <option value="amano">Import Amano Report</option>
                </Input>
            </Col>
        </Row>
    );
};

ImportReportSelectBox.propTypes = {
    loading: PropTypes.bool.isRequired,
    setImportProsprEmployeeReportModal: PropTypes.func.isRequired,
    setImportLaborSpreadsheetReportModal: PropTypes.func.isRequired,
    setImportSpotHeroReportModal: PropTypes.func.isRequired,
    setImportSureParkReportModal: PropTypes.func.isRequired,
    setImportCoast2CoastReportModal: PropTypes.func.isRequired,
};

export default ImportReportSelectBox;